export class RemoveFilterAction {
    public static readonly type = '[JobsPlacements] Remove filter';

    constructor(public filterId: number) { }
}
